/**
 * AMOMENTO Product Page JavaScript - 색상 동적 로드 기능 추가
 */

// ========================================
// 글로벌 Shopify API 요청 큐 - 429 방지
// 모든 Shopify fetch를 직렬화하여 동시 요청 차단
// ========================================
window._shopifyQueue = window._shopifyQueue || {
  busy: false,
  queue: [],
  async run(fn) {
    return new Promise((resolve, reject) => {
      this.queue.push({ fn, resolve, reject });
      this._process();
    });
  },
  async _process() {
    if (this.busy || this.queue.length === 0) return;
    this.busy = true;
    const { fn, resolve, reject } = this.queue.shift();
    try {
      const result = await fn();
      resolve(result);
    } catch (e) {
      reject(e);
    }
    // 요청 사이 500ms 간격 유지
    await new Promise(r => setTimeout(r, 500));
    this.busy = false;
    this._process();
  }
};

class ProductPage {
    constructor() {
      // DOM 요소 존재 확인
      this.container = document.querySelector('.product-container');
      if (!this.container) {
        console.error('Product container not found');
        return;
      }
  
      // 데이터 초기화
      this.initializeData();
      
      // 컴포넌트 초기화
      this.initializeComponents();
      
      // 이벤트 바인딩
      this.bindEvents();
      
      // 초기 상태 설정
      this.updateVariantStates();
      
      // 색상 옵션 로드
      this.loadColorOptions();
    }
  
    initializeData() {
      const productDataEl = document.getElementById('productData');
      const productData = productDataEl ? JSON.parse(productDataEl.textContent) : {};
      
      this.productId = this.container.dataset.productId;
      this.showPrice = this.container.dataset.showPrice === 'true';
      this.currency = this.container.dataset.currency;
      
      const wspPriceEl = document.querySelector('.wsp-price');
      this.wspPrice = wspPriceEl ? parseFloat(wspPriceEl.dataset.price) || 0 : 0;

      const rrpPriceEl = document.querySelector('.rrp-price');
      this.rrpPrice = rrpPriceEl ? parseFloat(rrpPriceEl.dataset.price) || 0 : 0;

      // 가격 우선순위: WSP > custom_price(RRP) > 0
      const customPriceEl = document.querySelector('[data-custom-price]');
      this.customPrice = customPriceEl ? parseFloat(customPriceEl.dataset.customPrice) || 0 : 0;
      this.basePrice = this.wspPrice || this.customPrice || this.rrpPrice;
      this.variants = productData.variants || [];
      this.thumbnails = productData.thumbnails || {};
      this.options = productData.options || [];
      this.displaySku = productData.displaySku || '';
      
      this.selectedOptions = {};
      this.quantities = {};
    }
  
    initializeComponents() {
      this.initializeGallery();
      this.initializeOptions();
      this.initializeQuantitySelectors();
      this.initializeTabs();
      this.displaySKU();
      this.formatInitialPrice();
    }
  
    initializeGallery() {
      this.mainImage = document.getElementById('mainImg');
      this.thumbnailElements = document.querySelectorAll('.thumbnail');
    }
  
    initializeOptions() {
      const hiddenColorInput = document.querySelector('.color-hidden-input');
      if (hiddenColorInput) {
        this.selectedOptions[hiddenColorInput.dataset.optionName] = hiddenColorInput.value;
      }
      
      document.querySelectorAll('.option-select').forEach(select => {
        const optionName = select.dataset.optionName;
        this.selectedOptions[optionName] = select.value;
      });
    }
  
    initializeQuantitySelectors() {
      this.quantityInputs = document.querySelectorAll('.quantity-input');
      this.totalAmountEl = document.getElementById('totalAmount');
      this.totalQuantityEl = document.getElementById('totalQuantity');
    }
  
    initializeTabs() {
      this.tabButtons = document.querySelectorAll('.tab-button');
      this.tabPanes = document.querySelectorAll('.tab-pane');
    }
  
    displaySKU() {
      const productCodeEl = document.querySelector('.product-code');
      if (productCodeEl && this.displaySku) {
        productCodeEl.textContent = this.displaySku;
      }
    }
  
    formatInitialPrice() {
      // WSP 가격은 이미 liquid에서 포맷팅되어 있음
    }
  
    // 색상 옵션 동적 로드
    async loadColorOptions() {
      const colorList = document.getElementById('colorList');
      if (!colorList) return;
      
      const baseName = colorList.dataset.baseName;
      const currentColor = colorList.dataset.currentColor;
      
      if (!baseName) return;
      
      try {
        // Shopify Search API 사용 (큐를 통해 rate limit 방지)
        const searchQuery = encodeURIComponent(baseName);
        const data = await window._shopifyQueue.run(async () => {
          const response = await fetch(`/search/suggest.json?q=${searchQuery}&resources[type]=product&resources[limit]=50`);
          return response.json();
        });
        
        if (data?.resources?.results?.products) {
          const colorProducts = data.resources.results.products.filter(product => {
            // 제목이 baseName으로 시작하고 콤마가 있는지 확인
            const title = product.title;
            return title.toLowerCase().startsWith(baseName.toLowerCase()) && title.includes(',');
          });
          
          // 현재 제품을 제외한 색상 옵션 추가
          const addedColors = new Set([currentColor]);
          
          colorProducts.forEach(product => {
            if (product.id.toString() !== this.productId) {
              const parts = product.title.split(',');
              if (parts.length > 1) {
                const color = parts[1].trim();
                if (!addedColors.has(color)) {
                  addedColors.add(color);
                  const colorLink = document.createElement('a');
                  colorLink.href = product.url;
                  colorLink.className = 'color-link';
                  colorLink.textContent = `• ${color}`;
                  colorList.appendChild(colorLink);
                }
              }
            }
          });
          
  
        }
      } catch (error) {
        console.error('Error loading color options:', error);
        
        // 에러 발생 시에도 메시지 표시하지 않음
        console.error('Error loading color options:', error);
      }
    }
  
    bindEvents() {
      // 썸네일 클릭
      this.thumbnailElements.forEach(thumb => {
        thumb.addEventListener('click', (e) => this.handleThumbnailClick(e));
      });
      
      // 탭 버튼 클릭
      this.tabButtons.forEach(button => {
        button.addEventListener('click', (e) => this.handleTabClick(e));
      });
      
      // 드롭다운 옵션 변경
      document.querySelectorAll('.option-select').forEach(select => {
        select.addEventListener('change', (e) => this.handleOptionChange(e));
      });
      
      // 수량 입력 변경
      this.quantityInputs.forEach(input => {
        input.addEventListener('change', (e) => this.handleQuantityChange(e));
        input.addEventListener('input', (e) => this.handleQuantityChange(e));
      });
      
      // 폼 제출
      const form = document.getElementById('productForm');
      if (form) {
        form.addEventListener('submit', (e) => this.handleFormSubmit(e));
      }
    }
  
    handleThumbnailClick(e) {
      const thumbnail = e.currentTarget;
      const newSrc = thumbnail.dataset.image;
      
      if (this.mainImage && newSrc) {
        this.mainImage.src = newSrc;
        
        this.thumbnailElements.forEach(thumb => {
          thumb.classList.toggle('active', thumb === thumbnail);
        });
      }
    }
  
    handleTabClick(e) {
      e.preventDefault();
      const clickedButton = e.currentTarget;
      const targetTab = clickedButton.dataset.tab;
      
      // 모든 탭 버튼과 패널 비활성화
      this.tabButtons.forEach(button => {
        button.classList.remove('active');
      });
      
      this.tabPanes.forEach(pane => {
        pane.classList.remove('active');
      });
      
      // 클릭한 탭 활성화
      clickedButton.classList.add('active');
      const targetPane = document.getElementById(`${targetTab}-tab`);
      if (targetPane) {
        targetPane.classList.add('active');
      }
    }
  
    handleOptionChange(e) {
      const select = e.target;
      const optionName = select.dataset.optionName;
      
      this.selectedOptions[optionName] = select.value;
      this.updateVariantStates();
    }
  
    handleQuantityChange(e) {
      const input = e.target;
      const value = parseInt(input.value) || 0;
      const maxValue = parseInt(input.max) || 999;
      
      if (value < 0) {
        input.value = 0;
      } else if (value > maxValue) {
        input.value = maxValue;
      }
      
      this.updateTotals();
    }
  
    updateVariantStates() {
      const sizeRows = document.querySelectorAll('.size-quantity-row');
      
      sizeRows.forEach(row => {
        const size = row.dataset.size;
        const variant = this.findVariant(this.selectedOptions['Color'] || this.selectedOptions['color'], size);
        const quantityInput = row.querySelector('.quantity-input');
        const statusEl = row.querySelector('.size-status');
        
        if (variant && variant.available) {
          row.classList.remove('disabled');
          quantityInput.disabled = false;
          quantityInput.dataset.variantId = variant.id;
          
          if (statusEl) {
            statusEl.textContent = '';
          }
        } else {
          row.classList.add('disabled');
          quantityInput.disabled = true;
          quantityInput.value = 0;
          
          if (statusEl) {
            statusEl.textContent = variant ? 'Out of stock' : 'Unavailable';
          }
        }
      });
      
      this.updateTotals();
    }
  
    findVariant(color, size) {
      return this.variants.find(variant => {
        const options = variant.options;
        return (!color || options.includes(color)) && options.includes(size);
      });
    }
  
    updateTotals() {
      let totalQuantity = 0;
      let totalAmount = 0;
      
      this.quantityInputs.forEach(input => {
        if (!input.disabled) {
          const quantity = parseInt(input.value) || 0;
          totalQuantity += quantity;
          
          if (this.showPrice) {
            totalAmount += quantity * this.basePrice;
          }
        }
      });
      
      if (this.totalQuantityEl) {
        this.totalQuantityEl.textContent = totalQuantity;
      }
      
      if (this.totalAmountEl && this.showPrice) {
        this.totalAmountEl.textContent = this.formatPrice(totalAmount);
      }
      
      const addToCartBtn = document.getElementById('addToCartBtn');
      if (addToCartBtn) {
        // ★ 에이전시 마스터는 스토어를 고르기 전까지 수량이 있어도 비활성 유지
        addToCartBtn.disabled = totalQuantity === 0 || this.needsAgencyStore();
      }
    }

    // 에이전시 마스터 버튼(.agency-add-to-cart)이고 가격 tier가 있는 스토어가 선택되지 않았으면 true
    // (product.liquid의 updateProductPrice와 같은 조건)
    needsAgencyStore() {
      const btn = document.getElementById('addToCartBtn');
      if (!btn || !btn.classList.contains('agency-add-to-cart')) return false;
      const proxyData = window.getProxyStore ? window.getProxyStore() : null;
      return !(proxyData && proxyData.store && proxyData.store.price_tier);
    }
  
    formatPrice(amount) {
      const intAmount = Math.round(amount);
      const formattedAmount = intAmount.toLocaleString('en-US');
      
      switch(this.currency) {
        case 'USD':
          return `$${formattedAmount}`;
        case 'EUR':
          return `€${formattedAmount}`;
        case 'JPY':
          return `¥${formattedAmount}`;
        case 'KRW':
          return `₩${formattedAmount}`;
        default:
          return `$${formattedAmount}`;
      }
    }
  
    async handleFormSubmit(e) {
      e.preventDefault();

      if (this.needsAgencyStore()) {
        alert('Please select a store first.');
        return;
      }

      const itemsToAdd = [];
      this.quantityInputs.forEach(input => {
        const quantity = parseInt(input.value) || 0;
        if (quantity > 0 && input.dataset.variantId) {
          const variant = this.variants.find(v => v.id == input.dataset.variantId);
          const sku = variant ? variant.sku : '';
          itemsToAdd.push({
            id: input.dataset.variantId,
            quantity: quantity,
            properties: {
              '_thumb': this.thumbnails[input.dataset.variantId] || '',
              '_size': input.dataset.size,
              '_sku': sku
            }
          });
        }
      });
      
      if (itemsToAdd.length === 0) {
        alert('Please select at least one item to add to cart.');
        return;
      }
      
      await this.addToCart(itemsToAdd);
    }
  
    async addToCart(items) {
      const addToCartBtn = document.getElementById('addToCartBtn');
      const originalText = addToCartBtn.textContent;

      // 실패 시 되돌릴 수 있도록 현재 수량 스냅샷
      const snapshot = Array.from(this.quantityInputs).map(input => ({ input, value: input.value }));

      // ★ 낙관적 UI: 서버 응답을 기다리지 않고 즉시 '담긴 것처럼' 표시 (체감 즉시)
      addToCartBtn.textContent = 'Added!';
      addToCartBtn.disabled = true;
      this.quantityInputs.forEach(input => input.value = 0);
      this.updateTotals();

      // 1초 뒤 버튼 원복 (연속 담기 시 더블클릭 방지 겸 UI 리셋)
      const resetTimer = setTimeout(() => {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = originalText;
      }, 1000);

      // ★ 실제 저장은 백그라운드에서 (큐로 직렬화 유지)
      try {
        await window._shopifyQueue.run(async () => {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!res.ok) {
            const errorData = await res.json().catch(() => ({}));
            throw new Error(errorData.description || errorData.message || `HTTP ${res.status}`);
          }
        });
      } catch (error) {
        // ★ 실패: 낙관적으로 지운 수량을 복원하고 명확히 알림 (B2B 정확성)
        console.error('Error adding to cart:', error);
        clearTimeout(resetTimer);
        snapshot.forEach(s => { s.input.value = s.value; });
        this.updateTotals();
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = originalText;
        alert('담기에 실패했습니다. 수량을 복원했어요. 다시 시도해 주세요.\n(' + error.message + ')');
      }
    }
  }
  
  // DOM 로드 완료 후 초기화
  document.addEventListener('DOMContentLoaded', () => {
    new ProductPage();
  });